import { useState } from "react";
import { useTranslation } from "react-i18next";
export const useOrderForm = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    address: "",
    payment: "",
    deliveryDate: "",
    note: "",
    deliveryRate:"",
  });

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    address: "",
    payment: "",
    deliveryDate: "",
    note: "",
  });

  const validateField = (field, value) => {
    switch (field) {
      case "firstName":
      case "lastName":
        if (!value.trim()) return t('error_requiredField');
        if (!/^[\u0590-\u05FF\u0600-\u06FFa-zA-Z\s]+$/.test(value.trim()))
          return t('error_letterOnlyField');
        return "";

      case "phone":
        // Only 9 digits and must start with "05"
        return /^05\d{8}$/.test(value) ? "" : t("error_invalidPhoneNumber");

      case "email":
        if (!value) return "";
        if (value.trim() && /\S+@\S+\.\S+/.test(value) && value.length <= 100) {
          return "";
        } else return t("error_invalidEmail");
      case "address":
        return value ? "" : t("error_pickAddress");
      case "payment":
        return value ? "" : t("error_pickPaymentMethod");
      case "deliveryDate":
        return value ? "" : t("error_pickDeliveryDate");
      default:
        return "";
    }
  };

  const handleChange = (field) => (event) => {
    const value = event && event.target ? event.target.value : event;
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
    setErrors({ ...errors, [field]: validateField(field, value) });
  };

  const validateStep = (step) => {
    const fieldsToValidate =
      step === 1
        ? ["firstName", "lastName", "phone", "email", "address"]
        : ["payment", "deliveryDate"];

    const newErrors = {};
    fieldsToValidate.forEach((field) => {
      newErrors[field] = validateField(field, formData[field]);
    });
    setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
    return Object.values(newErrors).every((error) => !error);
  };

  return {
    formData,
    errors,
    handleChange,
    validateStep,
    setFormData,
  };
};

// export const addresses = ["عين ماهل", "يافة الناصرة", "الناصرة", ];
export const paymentMethods = [
  { key: "paymentMethods.cashOnDelivery", value: "الدفع عند التوصيل" },
  // , "بطاقة ائتمان"
];
